import { PetLandingPageType } from '../shared';

interface QuestionAndAnswer {
  question: string;
  answer: string;
  analytics: string;
}

export const PRE_EXISTING_CONDITION_INDEX = 3;

export const getQuestionsAndAnswers = (petLandingPageType: PetLandingPageType): QuestionAndAnswer[] => [
  {
    question: 'What are waiting periods?',
    answer:
      'Like all pet insurers, we have waiting periods before certain coverages kick in - 14 days for illnesses and 30 days for orthopedic conditions. But if you opted for our preventative package, you can use the benefits in that package the day after you purchased the policy!',
    analytics: 'waiting_periods',
  },
  {
    question: 'What are pre-existing conditions and are they covered?',
    answer:
      petLandingPageType === PetLandingPageType.Cat
        ? 'Anything your cat has shown signs of before the waiting periods are up is considered a pre-existing condition. We don’t cover pre-existing conditions, but we’ve got your back in case of accidents and new illnesses, as part of our base coverage.'
        : `Anything your ${
            petLandingPageType.split('_')[0]
          } has shown signs of before the waiting periods are up is considered a pre-existing condition. Currently, we don’t cover pre-existing conditions, but we’ve got your back in case of accidents and new illnesses, as part of our base coverage.`,

    analytics: 'pre_existing_conditions_covered',
  },
  {
    question: 'How will I get paid for a claim?',
    answer:
      'We’ll ask you to enter your bank account information as part of submitting your claim in the Lemonade app. Once it’s approved, we’ll issue payment directly into your account.',
    analytics: 'how_payments_work',
  },
  {
    question: 'How do I add another pet?',
    answer:
      'Each pet needs their own policy, but you’ll need to set them up one at a time. After purchasing a policy for your first pet, just hit the + symbol on your Lemonade app’s home screen to get a new quote for your other furry friend.',
    analytics: 'how_to_add_another_pet',
  },
  {
    question: 'Can I change my coverage after purchase?',
    answer:
      'You can request to increase your coverage within the first 14 days of your policy, and at your policy’s renewal. However, in most states, you can request to decrease your coverage at any time. All changes are subject to our underwriting team’s approval.',
    analytics: 'change_coverage_after_pay',
  },
  {
    question: 'Do you need my pet’s medical records?',
    answer: `We want to get to know your ${
      petLandingPageType.split('_')[0]
    } so we can provide the best coverage. Medical records show vital information and help us understand whether your ${
      petLandingPageType.split('_')[0]
    } has any previous health issues, a.k.a pre-existing conditions.`,
    analytics: 'medical_records',
  },
];
